<template>
  <v-container>
    <v-layout row wrap class="documents-row" :class="{'mt-1': $vuetify.breakpoint.smAndDown}">

      <!-- Vzory -->

      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 class="px-3 mt-2 mb-4">
            <h3>Vzory + všeobecné obchodní podmínky</h3>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3" v-if="me.spolupracovnik">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Dodatek SMOZ &ndash; GDPR pro&nbsp;spolupracovníky</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Dodatek_SMOZ_GDPR_pro_spolupracovniky.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3" v-if="me.spolupracovnik">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Souhlas se zasíláním newsletteru</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Souhlas_se_zasilanim_newsletteru_GDPR.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3" v-if="me.spolupracovnik">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Smlouva o&nbsp;obchodním zastoupení</h3>
              </div>
              <div class="text-xs-center">
                <a href="./20230206_Smlouva_o_obchodnim_zastoupeni_aktualni.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3" v-if="me.spolupracovnik">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Objednávka</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Objednavka.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3" v-if="me.spolupracovnik">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Kariérní plán</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Karierni_plan.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3" v-if="me.spolupracovnik">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Plná moc</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Plna_moc.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Všeobecné obchodní podmínky</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Vseobecne_obchodni_podminky.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

        </v-layout>
      </v-flex>

      <!-- Prospekty -->

      <v-flex xs12 v-if="me.spolupracovnik">
        <v-layout row wrap>
          <v-flex xs12 class="px-3 mt-2 mb-4">
            <h3>Prospekty/nabídky/akce</h3>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Drahé kovy vs akcie za&nbsp;20&nbsp;let</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Drahe_kovy_vs_akcie_graf_20_let.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Sleva na spoření pro&nbsp;spolupracovníka</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Sleva_na_sporeni_pro_spolupracovnika.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Druhy spoření +&nbsp;zp.bonus +&nbsp;slevy</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Druhy_sporeni_zp.bonus_slevy.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Druhy spoření se zpětným bonusem</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Druhy_sporeni_se_zpetnym_bonusem.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Zpětný bonus</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Zpetny_bonus.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Druhy spoření</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Druhy_sporeni.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Videa -->

      <v-flex xs12 v-if="me.spolupracovnik">
        <v-layout row wrap>
          <v-flex xs12 class="px-3 mt-2 mb-4">
            <h3>Videa</h3>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/video.svg" alt="Ikona">
                </div>
                <h3>Prezentace</h3>
              </div>
              <div class="text-xs-center">
                <a href="https://vimeo.com/255699679" class="documents-btn button" target="_blank">Zobrazit</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/video.svg" alt="Ikona">
                </div>
                <h3>Následná schůzka</h3>
              </div>
              <div class="text-xs-center">
                <a href="https://vimeo.com/255702959" class="documents-btn button" target="_blank">Zobrazit</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/video.svg" alt="Ikona">
                </div>
                <h3>Dluh USA zobrazený ve fyzické měně</h3>
              </div>
              <div class="text-xs-center">
                <a href="https://www.youtube.com/watch?v=XqUwr-Nkq9g" class="documents-btn button" target="_blank">Zobrazit</a>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Pomůcky -->

      <v-flex xs12 v-if="me.spolupracovnik">
        <v-layout row wrap>
          <v-flex xs12 class="px-3 mt-2 mb-4">
            <h3>Pomůcky</h3>
          </v-flex>
          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Bezhotovostní cesta do&nbsp;úrokového záporu podle MMF</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Bezhotovostni_cesta_do_urokoveho_zaporu_podle_MMF.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Hypoteční trh se drží při zemi. Banky nepatrně snižují úroky&hellip;</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Hypotecni_trh_se_drzi_pri_zemi.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>OECD výrazně zhoršila výhled růstu Německa a&nbsp;Itálie</h3>
              </div>
              <div class="text-xs-center">
                <a href="./OECD_vyrazne_zhorsila_vyhled_rustu_nemecka_a_italie.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>BAIL-IN</h3>
              </div>
              <div class="text-xs-center">
                <a href="./BAIL_IN.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="px-3">
            <div class="documents">
              <div>
                <div class="text-xs-center">
                  <img src="@/assets/images/document.svg" alt="Ikona">
                </div>
                <h3>Poplatky pojišťoven &ndash; nákladovost</h3>
              </div>
              <div class="text-xs-center">
                <a href="./Poplatky_pojistoven_nakladovost.pdf" class="documents-btn button" target="_blank">Stáhnout</a>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {

      }
    },
    computed: {
      me: function() {
        return window.$me;
      }
    },
  }
</script>
